// import { Button, Table } from "antd";
// import axios from "axios";
// import { useEffect, useState } from "react";
// import { baseUrl } from "../../../components/common/baseUrl";
// import { useNotify } from "../../../components/Notification";
// import { settings } from "../../../utils/config";

// const ListPermissionAddToMenu = (props) => {
//   const { existedListPermission, onSelectPermission, onRemovePermission } =
//     props;
//   const notify = useNotify();
//   const hasAccessToken = settings?.getCookie("access_token");

//   //#region state
//   const [listPermission, setListPermission] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   //#endregion state

//   //#region table
//   const columns = [
//     {
//       title: "STT",
//       dataIndex: "index",
//       key: "index",
//       render: (_text, _record, index) => {
//         return <span>{index + 1}</span>;
//       },
//     },
//     {
//       title: "Mã permission",
//       dataIndex: "name",
//       key: "name",
//       fixed: "left",
//       render: (name) => {
//         return <p style={{ color: "#4096ff" }}>{name}</p>;
//       },
//     },
//     {
//       title: "Mô tả",
//       dataIndex: "label",
//       key: "3",
//     },

//     {
//       title: "Hành động",
//       dataIndex: "operation",
//       align: "center",
//       width: "12.5%",
//       render: (_, record) => {
//         const isExisted = existedListPermission?.some(
//           (item) => item === record.id
//         );
//         return (
//           <div>
//             {isExisted ? (
//               <Button
//                 type="primary"
//                 children={"Bỏ chọn"}
//                 danger
//                 onClick={() => onRemovePermission([record.id])}
//               />
//             ) : (
//               <Button
//                 type="primary"
//                 children={"Chọn"}
//                 onClick={() => onSelectPermission([record])}
//               />
//             )}
//           </div>
//         );
//       },
//     },
//   ];
//   //#endregion table

//   //#region  fuction
//   const fetchActions = async () => {
//     try {
//       setIsLoading(true);
//       // const url = `${baseUrl}/api/v1/security/permissions/get-list-all-permission`;
//       const url = `${baseUrl}/api/v1/security/permissions/permission-parent`;
//       const response = await axios.get(url, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${hasAccessToken}`,
//         },
//       });

//       if (response.data.success && response.data.data) {
//         const result = response.data.data;
//         setListPermission(result || []);
//       }
//     } catch (error) {
//       notify.error({
//         message: "Thất bại",
//         description: error.response.data?.message,
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   //#endregion fuction

//   // useEffect
//   useEffect(() => {
//     fetchActions();
//   }, []);
//   // useEffect
//   return (
//     <>
//       <Table
//         columns={columns}
//         dataSource={listPermission}
//         loading={isLoading}
//         pagination={false}
//       />
//     </>
//   );
// };
// export default ListPermissionAddToMenu;

import {
  CheckCircleOutlined,
  KeyOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  SecurityScanOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Divider,
  Empty,
  Input,
  Row,
  Space,
  Typography,
} from "antd";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { baseUrl } from "../../../components/common/baseUrl";
import { useNotify } from "../../../components/Notification";
import { settings } from "../../../utils/config";
import { brand, semantic, neutral } from "../../../theme/tokens";

const { Title, Text } = Typography;

const ListPermissionAddToMenu = (props) => {
  const { existedListPermission, onSelectPermission, onRemovePermission } =
    props;
  const notify = useNotify();
  const hasAccessToken = settings?.getCookie("access_token");

  //#region state
  const [listPermission, setListPermission] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  //#endregion state

  // Filter permissions based on search
  const filteredPermissions = useMemo(() => {
    if (!searchText) return listPermission;
    return listPermission.filter(
      (item) =>
        item.name?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.label?.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [listPermission, searchText]);

  // Statistics
  const stats = useMemo(() => {
    const total = listPermission.length;
    const selected = existedListPermission?.length || 0;
    const available = total - selected;
    const selectedFromFiltered = filteredPermissions.filter((item) =>
      existedListPermission?.some((id) => id === item.id)
    ).length;
    return {
      total,
      selected,
      available,
      selectedFromFiltered,
      filtered: filteredPermissions.length,
    };
  }, [listPermission, existedListPermission, filteredPermissions]);

  //#region function
  const fetchActions = async () => {
    try {
      setIsLoading(true);
      const url = `${baseUrl}/api/v1/security/permissions/permission-parent`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${hasAccessToken}`,
        },
      });

      if (response.data.success && response.data.data) {
        const result = response.data.data;
        setListPermission(result || []);
      }
    } catch (error) {
      notify.error({
        message: "Thất bại",
        description:
          error.response?.data?.message || "Có lỗi xảy ra khi tải dữ liệu",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleBulkSelect = () => {
    const unselectedItems = filteredPermissions.filter(
      (item) => !existedListPermission?.some((id) => id === item.id)
    );

    if (unselectedItems.length > 0) {
      onSelectPermission(unselectedItems);
    }
  };

  const handleBulkRemove = () => {
    const selectedIds = filteredPermissions
      .filter((item) => existedListPermission?.some((id) => id === item.id))
      .map((item) => item.id);

    if (selectedIds.length > 0) {
      onRemovePermission(selectedIds);
    }
  };
  //#endregion function

  // useEffect
  useEffect(() => {
    fetchActions();
  }, []);

  // Render Permission Card
  const renderPermissionCard = (permission, index) => {
    const isSelected = existedListPermission?.some(
      (item) => item === permission.id
    );

    return (
      <Col xs={24} sm={12} md={8} lg={6} xl={4} key={permission.id}>
        <Card
          hoverable
          size="small"
          onClick={() => {
            if (isSelected) {
              onRemovePermission([permission.id]);
            } else {
              onSelectPermission([permission]);
            }
          }}
          style={{
            height: "200px",
            borderRadius: "12px",
            border: isSelected ? "2px solid #52c41a" : "1px solid #f0f0f0",
            backgroundColor: isSelected ? "#f6ffed" : "#ffffff",
            boxShadow: isSelected
              ? "0 4px 12px rgba(82, 196, 26, 0.2)"
              : "0 2px 8px rgba(0,0,0,0.1)",
            transition: "all 0.3s ease",
            position: "relative",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            cursor: "pointer",
            transform: isSelected ? "scale(1.02)" : "scale(1)",
          }}
          bodyStyle={{
            padding: "16px",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flex: 1,
            textAlign: "center",
          }}
        >
          {/* Hiển thị ID để debug */}
          <div
            style={{
              position: "absolute",
              top: "12px",
              left: "12px",
              fontSize: "10px",
              color: "#999",
            }}
          >
            ID: {permission.id}
          </div>

          {/* Status Badge */}
          <div style={{ position: "absolute", top: "12px", right: "12px" }}>
            {isSelected ? (
              <CheckCircleOutlined
                style={{
                  fontSize: "20px",
                  color: semantic.success,
                  backgroundColor: "#ffffff",
                  borderRadius: "50%",
                  padding: "2px",
                }}
              />
            ) : (
              <PlusCircleOutlined
                style={{
                  fontSize: "20px",
                  color: neutral[300],
                  backgroundColor: "#ffffff",
                  borderRadius: "50%",
                  padding: "2px",
                }}
              />
            )}
          </div>

          {/* Content - giữ nguyên phần còn lại */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            {/* Icon */}
            <div style={{ marginBottom: "16px" }}>
              <KeyOutlined
                style={{
                  fontSize: "15px",
                  color: isSelected ? "#52c41a" : "#1890ff",
                  padding: "12px",
                  backgroundColor: isSelected ? "#f6ffed" : "#f0f7ff",
                  borderRadius: "50%",
                  border: `3px solid ${isSelected ? "#52c41a" : "#1890ff"}`,
                  transition: "all 0.3s ease",
                }}
              />
            </div>

            {/* Permission Code */}
            <div style={{ marginBottom: "8px", width: "100%" }}>
              <Text
                code
                style={{
                  fontSize: "11px",
                  fontWeight: "600",
                  color: isSelected ? "#389e0d" : "#1890ff",
                  backgroundColor: isSelected ? "#f6ffed" : "#f0f7ff",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  border: `1px solid ${isSelected ? "#b7eb8f" : "#d6e4ff"}`,
                  display: "block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                  textAlign: "center",
                }}
                title={permission.name}
              >
                {permission.name}
              </Text>
            </div>

            {/* Title */}
            <div
              style={{
                minHeight: "40px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Text
                strong
                style={{
                  fontSize: "13px",
                  color: "#262626",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  lineHeight: "1.4",
                  textAlign: "center",
                }}
                title={permission.label}
              >
                {permission.label || "Không có mô tả"}
              </Text>
            </div>

            {/* Click hint */}
            <div style={{ marginTop: "12px" }}>
              <Text
                style={{
                  fontSize: "11px",
                  color: "#999",
                  fontStyle: "italic",
                }}
              >
                {isSelected ? "Click để bỏ chọn" : "Click để chọn"}
              </Text>
            </div>
          </div>
        </Card>
      </Col>
    );
  };

  return (
    <div
      style={{
        padding: "24px",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <Card
        style={{
          borderRadius: "12px",
          marginBottom: "24px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Row align="middle" justify="space-between">
          <Col>
            <Space align="center">
              <SecurityScanOutlined
                style={{ fontSize: "24px", color: brand.accent }}
              />
              <Title level={3} style={{ margin: 0, color: "#262626" }}>
                Quản lý Permission
              </Title>
            </Space>
          </Col>
          <Col>
            <Space>
              <Button
                type="primary"
                ghost
                onClick={handleBulkSelect}
                disabled={stats.filtered === stats.selectedFromFiltered}
                style={{ borderRadius: "8px" }}
              >
                Chọn tất cả ({stats.filtered - stats.selectedFromFiltered})
              </Button>
              <Button
                danger
                ghost
                onClick={handleBulkRemove}
                disabled={stats.selectedFromFiltered === 0}
                style={{ borderRadius: "8px" }}
              >
                Bỏ chọn tất cả ({stats.selectedFromFiltered})
              </Button>
            </Space>
          </Col>
        </Row>

        <Divider style={{ margin: "16px 0" }} />

        {/* Statistics */}
        <Row gutter={16} style={{ marginBottom: "16px" }}>
          <Col xs={24} sm={6}>
            <div
              style={{
                textAlign: "center",
                padding: "12px",
                backgroundColor: "#f0f7ff",
                borderRadius: "8px",
                border: "1px solid #d6e4ff",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: brand.accent,
                }}
              >
                {stats.total}
              </div>
              <div style={{ fontSize: "14px", color: "#666" }}>Tổng số</div>
            </div>
          </Col>
          <Col xs={24} sm={6}>
            <div
              style={{
                textAlign: "center",
                padding: "12px",
                backgroundColor: semantic.successSubtle,
                borderRadius: "8px",
                border: "1px solid #b7eb8f",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: semantic.success,
                }}
              >
                {stats.selected}
              </div>
              <div style={{ fontSize: "14px", color: "#666" }}>Đã chọn</div>
            </div>
          </Col>
          <Col xs={24} sm={6}>
            <div
              style={{
                textAlign: "center",
                padding: "12px",
                backgroundColor: "#fff7e6",
                borderRadius: "8px",
                border: "1px solid #ffd591",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: semantic.warning,
                }}
              >
                {stats.available}
              </div>
              <div style={{ fontSize: "14px", color: "#666" }}>Có thể chọn</div>
            </div>
          </Col>
          <Col xs={24} sm={6}>
            <div
              style={{
                textAlign: "center",
                padding: "12px",
                backgroundColor: "#f9f0ff",
                borderRadius: "8px",
                border: "1px solid #d3adf7",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#722ed1",
                }}
              >
                {stats.filtered}
              </div>
              <div style={{ fontSize: "14px", color: "#666" }}>Hiển thị</div>
            </div>
          </Col>
        </Row>

        {/* Search */}
        <Input
          placeholder="🔍 Tìm kiếm theo mã permission hoặc mô tả..."
          prefix={<SearchOutlined style={{ color: neutral[400] }} />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          allowClear
          size="large"
          style={{
            borderRadius: "10px",
            fontSize: "14px",
          }}
        />
      </Card>

      {/* Permission Grid */}
      <Card
        loading={isLoading}
        style={{
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          minHeight: "400px",
        }}
      >
        {filteredPermissions.length === 0 && !isLoading ? (
          <Empty
            description="Không tìm thấy permission nào"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        ) : (
          <Row gutter={[16, 16]} style={{ padding: "8px 0" }}>
            {filteredPermissions.map((permission, index) =>
              renderPermissionCard(permission, index)
            )}
          </Row>
        )}
      </Card>
    </div>
  );
};

export default ListPermissionAddToMenu;
